


































// 我的收藏
import DownloadDia from '@/components/DownLoadDia.vue'; // 下载弹框组件
import Vue from 'vue';
import * as api from '@/api';
import CardProduct from '@/components/CardProduct.vue';
import CardContainer from '@/components/CardContainer.vue';

export default Vue.extend({
    components: {
        CardProduct,
        CardContainer,
        DownloadDia,
    },
    data() {
        return {
            dataLoading: true,
            productCards: [] as api.ProductCard[],
            totalCount: 0,
            search: '',
            fileTypes: [],
            dialogVisible: {
                show: false,
            },
        };
    },
    async created() {
        this.getUserProductsCollected();
    },
    methods: {
        async downloadFile(item) {
            const fileTypes = await api.getFileTypes({ id: item.productId, pvId: item.pvId });
            if (!api.error(fileTypes)) {
                fileTypes.data.length === 0 && this.$message({ type: 'info', message: '暂无模型文件可供下载' });
                fileTypes.data.length > 0 && (this.fileTypes = fileTypes.data) && (this.dialogVisible.show = true);
            }
        },
        async getUserProductsCollected() {
            this.dataLoading = true;
            const res = await api.getUserProductsCollected({});
            if (!api.error(res)) {
                this.productCards = res.data.items.filter((data) => !this.search || data.name.toLowerCase().includes(this.search.toLowerCase()));
                this.totalCount = this.productCards.length;
            }
            this.dataLoading = false;
        },
        async loadMore() {
            this.dataLoading = true;
            const res = await api.getUserProductsCollected({
                SkipCount: this.productCards.length,
            });
            if (!api.error(res)) {
                this.productCards = [...this.productCards, ...(res.data.items.filter((data) => !this.search || data.name.toLowerCase().includes(this.search.toLowerCase())))];
            }
            this.dataLoading = false;
        },
    },
});
